var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.654 10.346 C 3.859 10.551 4.191 10.551 4.396 10.346 L 9.45 5.292 L 9.45 9.275 C 9.45 9.565 9.685 9.8 9.975 9.8 C 10.265 9.8 10.5 9.565 10.5 9.275 L 10.5 4.025 C 10.5 3.735 10.265 3.5 9.975 3.5 L 4.725 3.5 C 4.435 3.5 4.2 3.735 4.2 4.025 C 4.2 4.315 4.435 4.55 4.725 4.55 L 8.708 4.55 L 3.654 9.604 C 3.449 9.809 3.449 10.141 3.654 10.346 Z",
    fill: "rgb(255, 255, 255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmall);
export default __webpack_public_path__ + "static/media/ArrowSmall.de2e99c3364a08ff805467b224bf1595.svg";
export { ForwardRef as ReactComponent };